import { RG_L, RG_R, RG_WORD } from './logoPaths';

export const RingaLogo = ({ className, word = true }: { className?: string; word?: boolean }) => (
  <svg className={className} viewBox={word ? '0 0 367 148' : '8 8 130 132'} role="img" aria-label="Ringa">
    <g fill="#E6630B">
      <path d={RG_L} />
      <circle cx="73" cy="73.5" r="9.09" />
      <path d={RG_R} />
    </g>
    {word && <path d={RG_WORD} fill="currentColor" />}
  </svg>
);

// one half of the symbol, used as typographic brackets around a tagline
export const Bracket = ({ side, className }: { side: 'l' | 'r'; className?: string }) => (
  <svg className={className} viewBox={side === 'l' ? '6 10 42 128' : '98 10 42 128'} aria-hidden="true" focusable="false">
    <path d={side === 'l' ? RG_L : RG_R} />
  </svg>
);
